<template>
  <div>
    <Banner :title="title" />
    <div class="py-5 px-2 text-center full">
      <div class="unsub-card">
        <h2 class="text-center mb-5">Unsubscribed Successfully</h2>
        <p v-if="!isUnsubscribed" v-html="messageTemp"></p>
        <p v-else v-html="message"></p>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import axios from "axios";

export default {
  name: "Unsubscribe",
  components: {
    Banner: Banner
  },
  data: () => ({
    title: "We're sorry to see you go!",
    messageTemp: "<p>We're deactivating your account. Please wait.</p>",
    message:
      '<p>You have been unsubscribed. If you would ever like to resubscribe, you can sign back up at <a href="http://rmofchaplin.ca/">here</a></p>',
    isUnsubscribed: false
  }),
  created() {
    axios
      .get(
        process.env.VUE_APP_SERVER + "unsubscribe/" + this.$route.params.email
      )
      .then(res => {
        if (res.data.success) {
          this.isUnsubscribed = true;
        }
      })
      .catch(error => console.error(error));
  }
};
</script>

<style scoped>
.full {
  min-height: 70vh !important;
}

.unsub-card {
  max-width: 500px;
  width: 100%;
  padding: 2rem;
  border-radius: 5px;
  border: solid 1px #888;
  box-shadow: 0 0 5px #ccc;
  margin: 2rem auto;
  min-width: 300px;
}
</style>
